module.exports = __webpack_public_path__ + "media/images/p-projectOverviews/operation-4df32b5f43434c50789f9fc265f807b8.svg";